/*
 * @Description: '关于我们'页面所有路由
*/

export default [
    {
        path: 'xw',
        component: resolve => require(['@/views/xw/index'], resolve),
        name: 'xw'
    },
  {
    path: 'xw_detail',
    component: resolve => require(['@/views/xw/detail'], resolve),
    name: 'xw_detail'
  }

]



// WEBPACK FOOTER //
// ./src/router/xw.js